import React, { Fragment, useContext, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import moment from "moment";
import * as Icon from "react-feather";
import LoadingBar from "react-top-loading-bar";

import deductibility from "../../../../shared/fixtures/deductibility";
import eo_subsection from "../../../../shared/fixtures/eo_subsection";
import filing_requirements from "../../../../shared/fixtures/filing_requirements";
import income_code from "../../../../shared/fixtures/income_code";
import { findOption } from "../../../../shared/helpers";

import { P } from "../../../atoms/Texts";

import ActionPageHero from "../../../molecules/ActionPageHero";
import affiliation from "../../../../shared/fixtures/affiliation";
import { LinkButton } from "../../../atoms/Buttons";
import { demoContext } from "../../../../shared/store/contexts";

const OrganizationDetailsPage = () => {
  const { id } = useParams();
  const { organization } = useContext(demoContext);
  const loader = useRef(null);

  return (
    <main className="flex flex-col w-full relative">
      <LoadingBar height={2} color="#00AF72" ref={loader} />
      <div className="flex justify-between items-center">
        <ActionPageHero
          className=""
          title={organization?.name}
          description={organization?.tagline}
          action
          actionComponent={
            // <Link to={`/dashboard/edit-organization/${id}`} className="pt-4 block">
            <LinkButton
              // color="#000000"
              className="flex items-center hover:underline"
              // className="whitespace-no-wrap mb-2 text-left hover:bg-blue-100 w-full"
              p="10px 20px"
            >
              Edit Organization Details
              <Icon.Edit2 className="ml-2" size={14} />
            </LinkButton>
            // </Link>
          }
          // back
          // goBackText="Back to All Organizations"
        />
      </div>
      <section className="mt-5 pb-10 md:py-18 mx-24">
        {organization?.id && (
          <>
            <div className="flex items-center">
              <div className="mb-4">
                <P color="" fontSize="14px" fontFamily="semi">
                  Description
                </P>
                <P fontSize="16px" className="">
                  {organization?.description}
                </P>
              </div>
            </div>
            {organization.url && organization.url !== "None" && (
              <div className="md:flex mt-6">
                <P
                  fontSize="14px"
                  className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                  fontFamily="semi"
                >
                  Alternate Name
                </P>
                <div className="md:w-4/5">
                  <P>{organization?.alternateName}</P>
                </div>
              </div>
            )}
            {organization.email && organization.email !== "None" && (
              <div className="md:flex mt-6 mb-4">
                <P
                  fontSize="14px"
                  className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                  fontFamily="semi"
                >
                  Email
                </P>
                <div className="md:w-4/5">
                  <a
                    href={`mailto:${organization.email}`}
                    className=""
                    style={{ width: "fit-content" }}
                  >
                    <P
                      className="mb-4 md:mb-0 hover:text-indigo-700"
                      style={{ width: "fit-content" }}
                    >
                      {organization.email}
                    </P>
                  </a>
                </div>
              </div>
            )}
            {organization.url && organization.url !== "None" && (
              <div className="md:flex mb-4">
                <P
                  fontSize="14px"
                  className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                  fontFamily="semi"
                >
                  Visit website
                </P>
                <div className="md:w-4/5">
                  <a
                    href={organization.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ width: "fit-content" }}
                    // className=" "
                  >
                    <P
                      className="mb-2 hover:text-indigo-700"
                      color="#2878F0"
                      style={{ width: "fit-content" }}
                    >
                      {organization.url}
                    </P>
                  </a>
                </div>
              </div>
            )}
            {organization.opCategory && (
              <div className="md:flex mb-4">
                <P
                  fontSize="14px"
                  className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                  fontFamily="semi"
                >
                  Category
                </P>
                <div className="md:w-4/5">
                  <P className="mb-2 capitalize">{organization.opCategory}</P>
                </div>
              </div>
            )}
            {organization.subOpCategory && (
              <div className="md:flex mb-4">
                <P
                  fontSize="14px"
                  className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                  fontFamily="semi"
                >
                  Subcategory
                </P>
                <div className="md:w-4/5">
                  <P className="mb-2">{organization.subOpCategory}</P>
                </div>
              </div>
            )}
            {organization.nteeType && (
              <div className="md:flex mb-4">
                <P
                  fontSize="14px"
                  className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                  fontFamily="semi"
                >
                  Ntee Type
                </P>
                <div className="md:w-4/5">
                  <P className="mb-2">{organization.nteeType}</P>
                </div>
              </div>
            )}
            {organization.nteeClassification && (
              <div className="md:flex mb-4">
                <P
                  fontSize="14px"
                  className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                  fontFamily="semi"
                >
                  Ntee Classification
                </P>
                <div className="md:w-4/5">
                  <P className="mb-2">{organization.nteeClassification}</P>
                </div>
              </div>
            )}
            {organization.contacts?.length > 0 && (
              <div className="md:flex mb-6">
                <P
                  fontSize="14px"
                  className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                  fontFamily="semi"
                >
                  Contacts
                </P>
                <div className="md:w-4/5">
                  {organization.contacts.map((contact, index) => (
                    <Fragment key={index}>
                      <P className="mb-0">
                        {contact.firstName} {contact.lastName}
                      </P>
                      <P className="mb-0">
                        {contact.title}, {contact.department}
                      </P>
                      <a
                        href={`mailto:${contact.email}`}
                        className=""
                        style={{ width: "fit-content" }}
                      >
                        <P
                          className="mb-4 md:mb-0 hover:text-indigo-700"
                          style={{ width: "fit-content" }}
                        >
                          {contact.email}
                        </P>
                      </a>
                    </Fragment>
                  ))}
                </div>
              </div>
            )}
            {organization.locations?.length > 0 && (
              <div className="md:flex mb-6">
                <P
                  fontSize="14px"
                  className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                  fontFamily="semi"
                >
                  Locations
                </P>
                <div className="md:w-4/5">
                  {organization.locations.map((location, index) => (
                    <React.Fragment key={index}>
                      <P className="mb-2">{location.name}</P>
                      {location?.address && (
                        <P className="mb-2">
                          {`${location.address}, ${location?.stateOrProvince} ${location?.zipCode}`}
                        </P>
                      )}
                      {location?.country && (
                        <P className="mb-2">{location?.country}.</P>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            )}
            {organization.phones?.length > 0 &&
              organization.phones?.[0]?.number !== "None" && (
                <div className="md:flex mb-6">
                  <P
                    fontSize="14px"
                    className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                    fontFamily="semi"
                  >
                    Phones
                  </P>
                  <div className="md:w-4/5">
                    {organization.phones.map((phone, index) => (
                      <a key={index} href={`tel:+${phone.extension}${phone.number}`}>
                        <P className="mb-2">
                          {phone.extension}
                          {phone.number}
                        </P>
                      </a>
                    ))}
                  </div>
                </div>
              )}
            {organization.ein && (
              <div className="md:flex mb-4">
                <P
                  fontSize="14px"
                  className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                  fontFamily="semi"
                >
                  EIN
                </P>
                <div className="md:w-4/5">
                  <P className="mb-2">{organization.ein}</P>
                </div>
              </div>
            )}
            {organization.deductibility && (
              <div className="md:flex mb-4">
                <P
                  fontSize="14px"
                  className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                  fontFamily="semi"
                >
                  Deductibility
                </P>
                <div className="md:w-4/5">
                  <P className="mb-2">
                    {findOption(organization.deductibility, deductibility)?.label}
                  </P>
                </div>
              </div>
            )}
            {organization.subsection && (
              <div className="md:flex mb-4">
                <P
                  fontSize="14px"
                  className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                  fontFamily="semi"
                >
                  Subsection
                </P>
                <div className="md:w-4/5">
                  <P className="mb-2">
                    {findOption(organization.subsection, eo_subsection)?.label}
                  </P>
                </div>
              </div>
            )}
            {organization.assetAmount && (
              <div className="md:flex mb-4">
                <P
                  fontSize="14px"
                  className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                  fontFamily="semi"
                >
                  Assest Amount
                </P>
                <div className="md:w-4/5">
                  <P className="mb-2">
                    {findOption(organization.assetAmount, income_code)?.label} USD
                  </P>
                </div>
              </div>
            )}
            {organization.incomeAmount && (
              <div className="md:flex mb-4">
                <P
                  fontSize="14px"
                  className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                  fontFamily="semi"
                >
                  Income Amount
                </P>
                <div className="md:w-4/5">
                  <P className="mb-2">
                    {findOption(organization.incomeAmount, income_code)?.label} USD
                  </P>
                </div>
              </div>
            )}
            {organization.filingRequirement && (
              <div className="md:flex mb-4">
                <P
                  fontSize="14px"
                  className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                  fontFamily="semi"
                >
                  Filing Requirement
                </P>
                <div className="md:w-4/5">
                  <P className="mb-2 capitalize">
                    {
                      findOption(organization.filingRequirement, filing_requirements)
                        ?.label
                    }
                  </P>
                </div>
              </div>
            )}
            {organization.latest990 && (
              <div className="md:flex mb-4">
                <P
                  fontSize="14px"
                  className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                  fontFamily="semi"
                >
                  Latest 990
                </P>
                <div className="md:w-4/5">
                  <P className="mb-2 capitalize">
                    {moment(organization.latest990).format("ll")}
                  </P>
                </div>
              </div>
            )}
            {organization.rulingDate && (
              <div className="md:flex mb-4">
                <P
                  fontSize="14px"
                  className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                  fontFamily="semi"
                >
                  Ruling Date
                </P>
                <div className="md:w-4/5">
                  <P className="mb-2 capitalize">
                    {moment(organization.rulingDate).format("ll")}
                  </P>
                </div>
              </div>
            )}
            {organization.affiliation && (
              <div className="md:flex mb-4">
                <P
                  fontSize="14px"
                  className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                  fontFamily="semi"
                >
                  Affliation
                </P>
                <div className="md:w-3/5">
                  <P className="mb-2">
                    {findOption(organization.affiliation, affiliation)?.label}
                  </P>
                </div>
              </div>
            )}
            {organization.accountingPeriod && (
              <div className="md:flex mb-4">
                <P
                  fontSize="14px"
                  className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                  fontFamily="semi"
                >
                  Account Period
                </P>
                <div className="md:w-4/5">
                  <P className="mb-2 capitalize">{organization.accountingPeriod}</P>
                </div>
              </div>
            )}
            {organization.exemptOrgStatus && (
              <div className="md:flex mb-4">
                <P
                  fontSize="14px"
                  className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                  fontFamily="semi"
                >
                  Exempt Organization
                </P>
                <div className="md:w-4/5">
                  <P className="mb-2 capitalize">{organization.exemptOrgStatus}</P>
                </div>
              </div>
            )}
          </>
        )}
      </section>
    </main>
  );
};

export default OrganizationDetailsPage;
